<script lang="ts" setup>
import { useBroadcast } from "~/stores/broadcast.store";
import { useContacts } from "~/stores/contacts.store";
import TemplatePreview from "~/views/trigger/components/ui/TemplatePreview.vue";

const broadcastStore = useBroadcast();
const contactsStore = useContacts();

const systemFields = contactsStore.getSystemFields;
const customFields = contactsStore.getCustomFields;

const fieldMap: Record<string, string> = Object.fromEntries(
  [...systemFields, ...customFields].map((f) => [f.id, f.name])
);
</script>

<template>
  <div class="message-preview">
    <TemplatePreview
      v-if="broadcastStore.selectedTemplate"
      :header-file="broadcastStore.headerFileV2"
      :template="broadcastStore.selectedTemplate"
      :variables="broadcastStore.variablesMap"
      :field-map="fieldMap"
      :key="broadcastStore.selectedTemplate.id"
    />
  </div>
</template>

<style lang="scss" scoped></style>
